import { combineReducers } from "@reduxjs/toolkit";

import { default as features } from "./features/reducer";
import { default as orderHistory } from "./orderHistory/reducer";
import { default as originalSupply } from "./originalSupply/reducer";
import { default as proactiveSales } from "./proactiveSales/reducer";

const personalizedAreaReducer = combineReducers({ features, originalSupply, orderHistory, proactiveSales });

export default personalizedAreaReducer;
